// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3axZt","newExpiryDate":"styles_newExpiryDate__2IXK3","footer":"styles_footer__2lwUI"};